// Components==============
import { AnimatePresence, motion } from 'framer-motion';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import { ReflectionItemContext } from 'pages/Growth/Reflect/components/ReflectionItem/ReflectionItem';
import React, { useContext } from 'react';
import { framerFade } from 'utilities/FramerAnimations';
import './EmojiSelector.module.scss';
import Input from './Input';
// =========================

export default function EmojiSelector({
  staticContent,
}: {
  staticContent?: EmotionsEntity[];
}) {
  const { saveState, setSaveState, save } = useContext(ReflectionItemContext);

  const translate = useTranslate();

  const emojis = useRedux((state) =>
    state.activity?.entities.allIds
      .map((id) => state.activity?.entities.byId[id])
      .filter((a) => a?.type === 'emotion')
      .sort((a, b) => (b?.order || 0) - (a?.order || 0))
  );

  const selected = (emoji?: number) =>
    !!saveState.emotions.find((e) => e.id === emoji);

  function handleClick(emoji?: number) {
    if (selected(emoji)) {
      save({
        ...saveState,
        emotions: saveState.emotions.filter((e) => e.id !== emoji),
      });

      return setSaveState((prev) => ({
        ...prev,
        emotions: prev.emotions.filter((e) => e.id !== emoji),
      }));
    }

    if (emoji) {
      save({
        ...saveState,
        emotions: [...saveState.emotions, { id: emoji, description: '' }],
      });

      setSaveState((prev) => ({
        ...prev,
        emotions: [...prev.emotions, { id: emoji, description: '' }],
      }));
    }
  }

  if (staticContent?.length) {
    return (
      <div styleName="static-emotions">
        {staticContent.map((emotion) => {
          const emoji = emojis?.find((e) => e?.id === emotion.id);
          if (!emoji) return <></>;

          return (
            <div styleName="emotion" key={emoji.name}>
              <img src={emoji.thumbnail} alt={emoji.name} />
              <p>
                {emoji.name} {translate('general.terms.because')}{' '}
                {emotion?.pivot.description}
              </p>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div styleName="wrapper">
      <div styleName="emojis">
        {emojis?.map((emoji) => (
          <div
            key={emoji?.id}
            styleName="emoji"
            onClick={() => handleClick(emoji?.id)}
          >
            <img src={emoji?.thumbnail} alt={emoji?.name} />
            <AnimatePresence>
              {selected(emoji?.id) && (
                <motion.div styleName="active" {...framerFade} />
              )}
            </AnimatePresence>
            <p style={{ opacity: selected(emoji?.id) ? 1 : '' }}>
              {emoji?.name}
            </p>
          </div>
        ))}
      </div>
      {!!saveState.emotions.length && (
        <div styleName="cards">
          <AnimatePresence>
            {saveState.emotions.map((e) => (
              <Input emotion={e} emojis={emojis} key={e.id} />
            ))}
          </AnimatePresence>
        </div>
      )}
    </div>
  );
}
